<script setup lang="ts">
defineProps<{ theme: string }>()
const userStore = useUserStore()
</script>

<template>
  <v-theme-provider :theme="theme">
    <v-app>
      <LayoutAppBar />
      <LayoutMobileMenuPrimary
        v-if="userStore.isAuthenticated"
        class="mobile-primary-menu"
      />
      <v-main>
        <LayoutMenuSecondary v-if="userStore.isAuthenticated" class="pl-3 pt-0 pr-3 menu-secondary" />
        <div class="main-wrapper">
          <v-container class="main-container" fluid>
            <slot />
          </v-container>
        </div>
      </v-main>
      <LayoutFooter />
      <VmzSnackbar class="snackbar-wrapper" />
    </v-app>
  </v-theme-provider>
</template>

<style scoped lang="scss">
  .desktop-menu {
    @media (min-width: 600px) {
      display: none;
    }
  }
  .mobile-primary-menu {
    @media (min-width: 960px) {
      display: none;
    }
  }
  .menu-secondary {
    @media (max-width: 960px) {
      display: none;
    }
  }
  .snackbar-wrapper {
    @media (max-width: 960px) {
      margin-bottom: 16px;
    }
  }
</style>
